import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';

type LightboxItem = {
    srcset?: string;
    msrc?: string;
    src: string;
    width: number,
    height: number,
    alt?: string;
};

function getOptimalImageSource(imgElement) {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const srcset = imgElement.srcset;
  const sources = srcset.split(',').map(source => {
    const [url, width] = source.trim().split(' ');
    return { url, width: parseInt(width.slice(0, -1)) };
  });

  // Sort sources by width in descending order
  sources.sort((a, b) => b.width - a.width);

  // Find the smallest source that fits the screen
  const { url, width } = sources.find(source => source.width <= screenWidth) || sources[sources.length - 1];

  // Calculate the height based on the aspect ratio of the original image dimensions
  const aspectRatio = imgElement.width / imgElement.height;
  const height = Math.round(width / aspectRatio);

  return { src: url, width, height };
}


function createLightBox(dataSource: LightboxItem[], index: number = 0) {
  const lightbox = new PhotoSwipe({ 
    dataSource, 
    index,
    showHideAnimationType: 'zoom',
    arrowPrevSVG: '⟵',
    arrowNextSVG: '⟶',
  });
  lightbox.addFilter('thumbEl', (thumbEl, data) => {
    const el = document.querySelector('img[src="' + data.src + '"]') as HTMLElement;
    return el || thumbEl;
  });
  lightbox.init();
};

function createGalleryLightbox($galleryElement: HTMLElement, $startingImage: HTMLImageElement) {
  const items = Array.from($galleryElement.querySelectorAll('img')).map((img) => {
    const {srcset, src, alt} = img;
    return {
      ...getOptimalImageSource(img),
      srcset,
      msrc: src,
      alt,
    };
  });

  const index = Array.from($galleryElement.querySelectorAll('img')).indexOf($startingImage);

  createLightBox(items, index);
}

function createSingleImageLightbox($imageElement: HTMLImageElement) {
  const {srcset, src, alt} = $imageElement;
  const items = [{
    ...getOptimalImageSource($imageElement),
    srcset,
    msrc: src,
    alt,
    
  }];

  createLightBox(items);
}

export function setupLightbox() {
  document.addEventListener('click', (event) => {
    const $target = event.target as HTMLElement;
  
    if ($target.matches('.kg-gallery-card img')) {
      createGalleryLightbox($target.closest('.kg-gallery-card') as HTMLElement, $target as HTMLImageElement);
    }
  
    if ($target.matches('.kg-image-card img')) {
      createSingleImageLightbox($target as HTMLImageElement);
    }
  });
}
